import { render, staticRenderFns } from "./ware-houses.vue?vue&type=template&id=135c7dbd&scoped=true"
import script from "./ware-houses.vue?vue&type=script&lang=js"
export * from "./ware-houses.vue?vue&type=script&lang=js"
import style0 from "./ware-houses.vue?vue&type=style&index=0&id=135c7dbd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c7dbd",
  null
  
)

export default component.exports